export const iconFontAwesomeCampingMosquitoNet = (
	<i className="fa-solid fa-mosquito-net"></i>
);
